export default __webpack_public_path__ + "static/media/amassedflames.50229356.png";